var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFileServerNoCircleDisabled(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 13",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "onprem no bg") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Licenses-",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "02-Licenses-Copy-3",
    transform: "translate(-364.000000, -499.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "card",
    transform: "translate(320.000000, 443.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "onprem-no-bg",
    transform: "translate(44.000000, 56.199000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24,-4.61852778e-14 L24,5.6 L5.32907052e-15,5.6 L5.32907052e-15,-4.61852778e-14 L24,-4.61852778e-14 Z M22.5,2.1 L21,2.1 L21,3.5 L22.5,3.5 L22.5,2.1 Z M19.5,2.1 L18,2.1 L18,3.5 L19.5,3.5 L19.5,2.1 Z M16.5,2.1 L15,2.1 L15,3.5 L16.5,3.5 L16.5,2.1 Z",
    id: "Combined-Shape",
    fill: "#A7A7A7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24,6.4 L24,12 L5.32907052e-15,12 L5.32907052e-15,6.4 L24,6.4 Z M22.5,8.5 L21,8.5 L21,9.9 L22.5,9.9 L22.5,8.5 Z M19.5,8.5 L18,8.5 L18,9.9 L19.5,9.9 L19.5,8.5 Z M16.5,8.5 L15,8.5 L15,9.9 L16.5,9.9 L16.5,8.5 Z",
    id: "Combined-Shape-Copy",
    fill: "#A7A7A7"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFileServerNoCircleDisabled);
export default __webpack_public_path__ + "static/media/file-server-no-circle-disabled.08a5e96d78140a79b286e91b774ccd7f.svg";
export { ForwardRef as ReactComponent };